
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelector('.js-gnb-open'),
		  gnb = document.querySelector('.js-gnb'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn'),
		  gnbDepth2 = document.querySelectorAll('.depth2');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.addEventListener('click' , function(){
			gnb.classList.add('active');
			body.classList.add('ovf');

			gnbToggleBtn.forEach(function(el){
				let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

				el.addEventListener('click' , function(e){
					if(el.classList.contains('active')){
						el.classList.remove('active');
					}else{
						gnbToggleBtnArray.forEach(function(el){
							el.classList.remove('active');
						});
						el.classList.add('active');
					}
				});
			})

			//gnb depth2 전체보기 하나일 때 col1 class 추가
			gnbDepth2.forEach(function(el){
				let targetLi = el.querySelectorAll('li').length;

				if(targetLi == 1){
					el.classList.add('col1');
				}
			})

			gnbCloseBtn.addEventListener('click' , function(){
				gnb.classList.remove('active');
				body.classList.remove('ovf');
			});
		});
	}

	//header nav
	if(document.querySelector('.nav')){
        let swiper = new Swiper('.nav', {
            slidesPerView: 'auto',
            spaceBetween: 1,
        });
	}

	//header height
	let headerH = document.getElementById('header').offsetHeight,
		contentH = document.querySelector('.content');

	if(document.querySelector('.lnb')){
		let lnbH = document.querySelector('.lnb').offsetHeight;

		contentH.style.marginTop = headerH + lnbH + 'px';
	}else if(document.querySelector('.top-area')){
		let topAreaH = document.querySelector('.top-area').offsetHeight;

		contentH.style.marginTop = headerH + topAreaH + 'px';
	}else{
		contentH.style.marginTop = headerH + 'px';
	}
	
	if(document.querySelector('.event-product-lists-page') || document.querySelector('.event-view-page') || document.querySelector('.brand-product-list-page')){
		document.querySelector('.lnb').style.top = headerH + 'px';
	}

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	//category menu - product, brand
	if(document.querySelector('.category')){
		$(".category .category__menu").slick({
			arrows:false,
			dots:false,
			variableWidth:true,
			infinite:false,
			slidesToShow:1,
			swipeToSlide:true,
		});
	}

	// footer - floating 상단으로
	if(document.querySelector('.top-move')){
		const topMove = document.querySelector('.top-move');

		window.addEventListener('scroll' , ()=>{
			if(window.pageYOffset >= topMove.clientHeight){
				topMove.classList.add('scroll');
			} else {
				topMove.classList.remove('scroll');
			}
		})
	}
});
